import React, { Component } from 'react';
import { Button } from 'antd';
import addToDownloadSite from '../../common/addToDownloadSite';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import { queryApprovalUserCachedAsync } from '../../../common/permissionCache';
import Filter from './Filter';
import FailureRecord from './FailureRecord';
import TableC from '../../basicElement/TableC';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../shared/cellRenderEnhancer';
import format from '../../shared/format';
import SideNav from '../SideNav';
import moment from 'moment';
import FieldSettingsModel from './FieldSettingsModel';
import { calcDisplayColumns } from './common';
import Exportcuredata from './Exportcuredata'

class FinanceIncomeReport extends Component {
    constructor(props) {
        super(props);
        const searchParams = {
            startOper: 'EQ',
            endOper: 'EQ',
            // dateStart:moment().format('YYYY-MM'),
            // dateEnd:moment().format('YYYY-MM'),
        };
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            curParams: { ...searchParams },
            searchParams,
            pagination: {
                pageSize: 10,
                current: 1,
            },
            columnsTitle: [],
            businessList: [],
            contractTypeList: [],
            showFailureRecord: false,
            signingUnitOptions: [],
            belongingToUnitOptions: [],
            endMonth: '',
            startMonth: '',
            operable: false,
        };
    }

    componentDidMount() {
        this.querySigningUnit();
        this.queryBelongingToUnit();
        this.loadTypeConfigureList();
        this.queryWithLevelByParams();
        //this.queryFixedLineTime();
        this.queryHead();
        this.queryApprovalUser();
    }

    // 查询财务管理权限
    queryApprovalUser = () => {
        queryApprovalUserCachedAsync('FIN_MODULE,TEACH_LEADER')
            .then(res => {
                this.setState({
                    isSeniorUserBo: res.isSeniorUserBo,
                    FINANCE_INCOME_REPORT_USER: res.FINANCE_INCOME_REPORT_USER,
                    isDesignatedTal: res.isDesignatedTal,
                });
            });
    }

    querySigningUnit = () => {
        dictCache.getDict('UNIT_SIGNING', cb => {
            Fetch.post(API_URL.contract.queryUnitOfSigningList, {
                offset: 1,
                limit: 999,
            }).then(cb);
        }, res => {
            const { datas = [] } = res;
            const signingUnitOptions = (datas || []).map(i => ({ value: i.unitOfSigningId, label: i.unitOfSigningName }));
            this.setState({ signingUnitOptions });
        });
    }

    queryBelongingToUnit = () => {
        dictCache.getDict('UNIT_BELONGING', cb => {
            Fetch.post(API_URL.contract.queryUnitOfBelongingList, {
                offset: 1,
                limit: 999,
            }).then(cb);
        }, res => {
            const { datas = [] } = res;
            const belongingToUnitOptions = (datas || []).map(i => ({ value: i.unitOfBelongingId, label: i.unitOfBelongingName }));
            this.setState({ belongingToUnitOptions });
        });
    }

    queryFixedLineTime = () => {
        Fetch.post(API_URL.finance.queryFixedLineTime).then(res => {
            const { data } = res;
            if (!data || data.length === 0) {
                this.setState({ operable: false });
                return;
            }
            const { searchParams } = this.state;
            const startMonth = moment(format('month', data[0].year, data[0].month)).format('YYYY-MM');
            const endMonth = moment(format('month', data[data.length - 1].year, data[data.length - 1].month)).format('YYYY-MM');
            searchParams.date = endMonth;
            this.setState({
                endMonth,
                startMonth,
                searchParams,
                operable: true,
                curParams: searchParams,
            }, () => {
                this.queryEffectiveDate();
            });
        });
    }

    queryEffectiveDate = () => {
        Fetch.post(API_URL.home.queryEffectiveDate).then(res => {
            const { date, month, year } = res;
            const { searchParams } = this.state;
            const endMonth = moment(date).format('YYYY-MM');
            searchParams.dateStart = endMonth;
            searchParams.dateEnd = endMonth;
            searchParams.month = month;
            searchParams.year = year;
            this.setState({ searchParams }
                , () => {
                    this.loadData();
                }
            );
        });
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList).then(cb);
        }, res => {
            const { contractTypeList } = res;
            this.setState({ contractTypeList });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, { typeName: 'LINE_OF_BUSINESS' }).then(cb);
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(curParams);
        Fetch.post(API_URL.finance.queryInvestigationJdeContractRecordList, {
            offset: current,
            limit: 10,
            ...sortParams,
            ...params,
        }).then(res => {
            const { datas, totalCount } = res;
            const page = Math.ceil(totalCount / pageSize)     //计算一共有多少页
            pagination.total = page * pagination.pageSize
            const { handAmounts, yearAmounts } = datas && datas.length ? datas[0] : {};
            pagination.total = Math.ceil(totalCount / 10) * datas.length;
            pagination.pageSize = datas.length;
            const columnsTitle = [];
            (handAmounts || []).forEach(i => {
                const { yearNum, monthNum, yearMonthNum } = i;
                if (monthNum > 0) {
                    columnsTitle.push({
                        title: `${yearNum}${monthNum < 10 ? `0${monthNum}` : monthNum}`,
                        //dataIndex: `${yearNum}${monthNum}`,
                        //key: `${yearNum}${monthNum}`,
                        dataIndex: `${yearMonthNum}`,
                        key: `${yearMonthNum}`,
                        width: 80,
                    });
                }
            });
            (yearAmounts || []).forEach(i => {
                const { yearNum } = i;
                columnsTitle.push({
                    title: `${yearNum}在手订单额合计`,
                    dataIndex: `${yearNum}`,
                    key: `${yearNum}`,
                    width: 80,
                });
            });
            datas.forEach(item => {
                const { handAmounts, yearAmounts } = item;
                (handAmounts || []).forEach(i => {
                    const { yearNum, monthNum, amount, yearMonthNum } = i;
                    if (monthNum > 0) {
                        //item[`${yearNum}${monthNum}`] = format('money', amount);
                        item[`${yearMonthNum}`] = format('money', amount);
                    }
                });
                (yearAmounts || []).forEach(i => {
                    const { yearNum, amount } = i;
                    item[`${yearNum}`] = format('money', amount);
                });
            });
            this.setState({
                loading: false,
                data: datas,
                pagination,
                columnsTitle,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: { ...searchParams }
        }, () => {
            this.resetHead();
        });
    }

    resetHead = () => {
        this.setState({ loading: true });
        const { searchParams } = this.state;
        Fetch.post(API_URL.common.queryUserCustomDisplayByUserId, {
            type: 'JDE_CONTRACT_RECORD',
            ...searchParams,
        }).then(res => {
            const { JDE_CONTRACT_RECORD } = res;
            this.setState({ loading: false });
            this.setState({ head: JDE_CONTRACT_RECORD }, () => {
                this.loadData();
            });
        }).catch(error => {
            console.error(error);
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const params = this.splitParams(curParams);
        const url = API_URL.finance.exportInvestigationJdeContractRecordList;
        addToDownloadSite({ ...sortParams, ...params }, url, 'FINANCE_INCOME');
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleStringLinefeed = (text) => {
        const arr = (text || '').split(',');
        const result = arr.map((item, index) => {
            return <span key={index}>{item}{index < arr.length - 1 ? ',' : ''}<br /></span>;
        });
        return result;
    }

    getRender = (key) => (text, record) => record[key] ? record[key] : text

    queryHead = () => {
        const { searchParams } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.common.queryUserCustomDisplayByUserId, {
            type: 'JDE_CONTRACT_RECORD',
            ...searchParams,
        }).then(res => {
            const { JDE_CONTRACT_RECORD } = res;
            this.setState({ loading: false });
            this.setState({ head: JDE_CONTRACT_RECORD }, () => {
                this.queryFixedLineTime();
            });
        }).catch(error => {
            console.error(error);
        });
    }

    getColumns = () => {
        const { columnsTitle, head, data } = this.state;
        const columns = [{
            title: '合同收入确认时间',
            dataIndex: 'recordYearMonthShow',
            key: 'recordYearMonthShow',
            fixed: 'left',
            width: 120,
            // render: (text, record) => {
            //     const { recordYear, recordMonth } = record;
            //     return `${recordYear}${recordMonth < 10 ? `0${recordMonth}` : recordMonth}`;
            // }
        }, {
            title: '合同签署单位',
            dataIndex: 'signingUnit',
            key: 'signingUnit',
            width: 100,
            render: this.getRender('signingUnitMerge'),
        }, {
            title: '收入归属单位',
            dataIndex: 'belongingToUnit',
            key: 'belongingToUnit',
            width: 100,
            render: this.getRender('belongingToUnitMerge'),
        }, {
            title: 'JDE项目号',
            dataIndex: 'jdeCode',
            key: 'jdeCode',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 120,
        },
        {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 120,
        },
        {
            title: '名称(Project ID)',
            dataIndex: 'projectIdName',
            key: 'projectIdName',
            width: 120,
            render: this.getRender('projectIdNameMerge'),
        }, {
            title: '合同是否签署完成',
            dataIndex: 'contractIsSignedMerge',
            key: 'contractIsSignedMerge',
            width: 80,
        }, {
            title: '合同新增时间',
            dataIndex: 'contractCreateTime',
            key: 'contractCreateTime',
            width: 90,
            render: this.getRender('createTimeMerge'),
        }, {
            title: '过账编辑',
            dataIndex: 'postingEdit',
            key: 'postingEdit',
            width: 80,
        }, {
            title: '类别码13',
            dataIndex: 'categoryCode13',
            key: 'categoryCode13',
            width: 90,
            render: (text, record) => {
                return text ? <span style={{ color: record.categoryCodeStatus == 1 && 'red' }}>{text}</span> : '';
            }
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessShow',
            key: 'lineOfBusinessShow',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '项目阶段',
            dataIndex: 'investigationStageNames',
            key: 'investigationStageNames',
            width: 90,
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
            width: 80,
            render: this.getRender('contractNatureMerge'),
        }, {
            title: '客户JDE号',
            dataIndex: 'customerJdeCode',
            key: 'customerJdeCode',
            width: 100,
            render: cellRenderEnhancer({
                renderContent: beforeChangeEnhancer((record) => record['oldCustomerCompanyCode'])
            })(this.getRender('customerJdeCodeMerge')),
        }, {
            title: '客户全名',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 100,
            render: cellRenderEnhancer({
                renderContent: beforeChangeEnhancer((record) => record['oldCustomerCompanyName'])
            })(this.getRender('customerCompanyNameMerge')),
        }, {
            title: 'PM工号',
            dataIndex: 'pmEmployeeCode',
            key: 'pmEmployeeCode',
            width: 80,
        }, {
            title: 'PM姓名',
            dataIndex: 'pmUserCompellation',
            key: 'pmUserCompellation',
            width: 80,
        }, {
            title: 'PM主管工号',
            dataIndex: 'pmLeaderEmployeeCode',
            key: 'pmLeaderEmployeeCode',
            width: 85,
        }, {
            title: 'PM主管姓名',
            dataIndex: 'pmLeaderUserCompellation',
            key: 'pmLeaderUserCompellation',
            width: 85,
        }, {
            title: 'BD工号',
            dataIndex: 'bdCodes',
            key: 'bdCodes',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: 'BD姓名',
            dataIndex: 'bdNames',
            key: 'bdNames',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: 'BA工号',
            dataIndex: 'baCodes',
            key: 'baCodes',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: 'BA姓名',
            dataIndex: 'baNames',
            key: 'baNames',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineTypeValue',
            key: 'investigationMedicineTypeValue',
            width: 100,
        }, {
            title: '项目分期',
            dataIndex: 'invByStageShow',
            key: 'invByStageShow',
            width: 120,
        }, {
            title: '受试者类型',
            dataIndex: 'testeeTypeName',
            key: 'testeeTypeName',
            width: 80,
        }, {
            title: '项目分类',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '项目领域',
            dataIndex: 'invAreaShow',
            key: 'invAreaShow',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeShow',
            key: 'contractTypeShow',
            width: 80,
            render: cellRenderEnhancer({
                renderContent: beforeChangeEnhancer((record) => record['oldContractTypeValue'])
            })(),
        }, {
            title: '合同开始时间',
            dataIndex: 'contractStartTime',
            key: 'contractStartTime',
            width: 90,
            render: (text, record) => {
                const { contractStartTimeMerge } = record;
                return contractStartTimeMerge ? contractStartTimeMerge : format('date', text);
            }
        }, {
            title: '合同结束时间',
            dataIndex: 'contractEndTime',
            key: 'contractEndTime',
            width: 90,
            render: (text, record) => {
                const { contractEndTimeMerge } = record;
                return contractEndTimeMerge ? contractEndTimeMerge : format('date', text);
            }
        }, {
            title: '合同中是否明标合同金额',
            dataIndex: 'contractIsSpecifiesAmountMerge',
            key: 'contractIsSpecifiesAmountMerge',
            width: 90,
        }, {
            title: '币种',
            dataIndex: 'currencyName',
            key: 'currencyName',
            width: 100,
        }, {
            title: '发票税率',
            dataIndex: 'invoiceRate',
            key: 'invoiceRate',
            width: 80,
            render: (text) => format('unit', text, '%'),
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
            width: 80,
        }, {
            title: 'FTE 单价(不含税)',
            dataIndex: 'fteUnitPriceNoTax',
            key: 'fteUnitPriceNoTax',
            width: 80,
        }, {
            title: '合同额含税/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '实报实销(不含税)/原币',
            dataIndex: 'initialActualExpenseFee',
            key: 'initialActualExpenseFee',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '实报实销税费/原币',
            dataIndex: 'initialActualFee',
            key: 'initialActualFee',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '合同额含税/人民币',
            dataIndex: 'cnyContractAmount',
            key: 'cnyContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '实报实销(不含税)/人民币',
            dataIndex: 'cnyActualExpenseFee',
            key: 'cnyActualExpenseFee',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '实报实销税费/人民币',
            dataIndex: 'cnyActualFee',
            key: 'cnyActualFee',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '服务费含税/原币',
            dataIndex: 'initialServiceFeeIncludeTax',
            key: 'initialServiceFeeIncludeTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '服务费不含税/原币',
            dataIndex: 'initialServiceFeeNoTax',
            key: 'initialServiceFeeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '服务费含税/人民币',
            dataIndex: 'cnyServiceFeeIncludeTax',
            key: 'cnyServiceFeeIncludeTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '服务费不含税/人民币',
            dataIndex: 'cnyServiceFeeNoTax',
            key: 'cnyServiceFeeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '截止当月末POC%',
            dataIndex: 'currentMonthEndPocShow',
            key: 'currentMonthEndPocShow',
            width: 80,
        }, {
            title: '截止到上月末POC%',
            dataIndex: 'lastMonthEndPocShow',
            key: 'lastMonthEndPocShow',
            width: 80,
        }, {
            title: '当月完成POC%',
            dataIndex: 'currentMonthFinishPocShow',
            key: 'currentMonthFinishPocShow',
            width: 100,
        }, {
            title: '当月开票金额(含税)/原币',
            dataIndex: 'initialCurrentMonthInvoice',
            key: 'initialCurrentMonthInvoice',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '累计开票金额(含税)/原币',
            dataIndex: 'initialTotalMonthInvoice',
            key: 'initialTotalMonthInvoice',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '累计开票百分比',
            dataIndex: 'totalInvoicePercent',
            key: 'totalInvoicePercent',
            width: 80,
        }, {
            title: '累计收入不含税/原币',
            dataIndex: 'initialTotalIncomeNoTax',
            key: 'initialTotalIncomeNoTax',
            width: 100,
            render: (text, record) => {
                const { initialTotalIncomeNoTaxIsRed } = record;
                return <span style={{ color: initialTotalIncomeNoTaxIsRed ? 'red' : 'rgba(0,0,0,.65)' }}>{format('money', text)}</span>
            },
        }, {
            title: '累计收入不含税/人民币',
            dataIndex: 'cnyTotalIncomeNoTax',
            key: 'cnyTotalIncomeNoTax',
            width: 100,
            render: (text, record) => {
                const { cnyTotalIncomeNoTaxIsRed } = record;
                return <span style={{ color: cnyTotalIncomeNoTaxIsRed ? 'red' : 'rgba(0,0,0,.65)' }}>{format('money', text)}</span>
            },
        }, {
            title: '累计上月收入不含税/原币',
            dataIndex: 'initialTotalLastMonthIncomeNoTax',
            key: 'initialTotalLastMonthIncomeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '累计上月收入不含税/人民币',
            dataIndex: 'cnyTotalLastMonthIncomeNoTax',
            key: 'cnyTotalLastMonthIncomeNoTax',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '当月服务费收入不含税/原币',
            dataIndex: 'initialCurrentMonthIncomeNoTax',
            key: 'initialCurrentMonthIncomeNoTax',
            width: 120,
            render: (text, record) => {
                const { initialCurrentMonthIncomeNoTaxIsRed } = record;
                return <span style={{ color: initialCurrentMonthIncomeNoTaxIsRed ? 'red' : 'rgba(0,0,0,.65)' }}>{format('money', text)}</span>
            },
        }, {
            title: '当月PT收入不含税/原币',
            dataIndex: 'initialCurrentMonthPtIncomeNoTax',
            key: 'initialCurrentMonthPtIncomeNoTax',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '当月Rebate金额不含税/原币',
            dataIndex: 'initialCurrentMonthRebateIncomeNoTax',
            key: 'initialCurrentMonthRebateIncomeNoTax',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '当月收入不含税/原币合计',
            dataIndex: 'initialCurrentMonthIncomeTotalNoTax',
            key: 'initialCurrentMonthIncomeTotalNoTax',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '当月服务费收入不含税/人民币',
            dataIndex: 'cnyCurrentMonthIncomeNoTax',
            key: 'cnyCurrentMonthIncomeNoTax',
            width: 120,
            render: (text, record) => {
                const { cnyCurrentMonthIncomeNoTaxIsRed } = record;
                return <span style={{ color: cnyCurrentMonthIncomeNoTaxIsRed ? 'red' : 'rgba(0,0,0,.65)' }}>{format('money', text)}</span>
            },
        }, {
            title: '当月PT收入不含税/人民币',
            dataIndex: 'cnyCurrentMonthPtIncomeNoTax',
            key: 'cnyCurrentMonthPtIncomeNoTax',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '当月Rebate金额不含税/人民币',
            dataIndex: 'cnyCurrentMonthRebateIncomeNoTax',
            key: 'cnyCurrentMonthRebateIncomeNoTax',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '当月收入不含税/人民币合计',
            dataIndex: 'cnyCurrentMonthIncomeTotalNoTax',
            key: 'cnyCurrentMonthIncomeTotalNoTax',
            width: 120,
            render: text => format('money', text),
        },
        // {
        //     title: '当年收入不含税/原币',
        //     dataIndex: 'initialCurrentYearIncomeNoTax',
        //     key: 'initialCurrentYearIncomeNoTax',
        //     width: 100,
        //     render: text => format('money', text),
        // }, {
        //     title: '当年收入不含税/人民币',
        //     dataIndex: 'cnyCurrentYearIncomeNoTax',
        //     key: 'cnyCurrentYearIncomeNoTax',
        //     width: 120,
        //     render: text => format('money', text),
        // },
        {
            title: '当月补充合同当月产生收入/原币',
            dataIndex: 'initialSupplementCurrentMonthIncome',
            key: 'initialSupplementCurrentMonthIncome',
            width: 120,
            render: (text, record) => {
                const { initialSupplementCurrentMonthIncomeIsRed } = record;
                return <span style={{ color: initialSupplementCurrentMonthIncomeIsRed ? 'red' : 'rgba(0,0,0,.65)' }}>{format('money', text)}</span>
            },
        }, {
            title: '当月补充合同当月产生收入/人民币',
            dataIndex: 'cnySupplementCurrentMonthIncome',
            key: 'cnySupplementCurrentMonthIncome',
            width: 100,
            render: (text, record) => {
                const { cnySupplementCurrentMonthIncomeIsRed } = record;
                return <span style={{ color: cnySupplementCurrentMonthIncomeIsRed ? 'red' : 'rgba(0,0,0,.65)' }}>{format('money', text)}</span>
            },
        }, {
            title: '在手订单额(不含税)',
            dataIndex: 'currentQuarterAmountNoTax',
            key: 'currentQuarterAmountNoTax',
            width: 100,
            render: text => format('money', text),
        }
        ];
        columns.push(...columnsTitle);
        columns.push({
            title: '在手订单额余额(不含税)/人民币',
            dataIndex: 'currentQuarterAmountRemainderNoTax',
            key: 'currentQuarterAmountRemainderNoTax',
            width: 110,
            render: text => format('money', text),
        });
        const result = data && data.length > 0 ? calcDisplayColumns(columns, head) : columns;
        return result;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showFailureRecord = (showFailureRecord) => {
        this.setState({ showFailureRecord });
    }

    showFieldSettings = () => {
        this.fieldSettingsRef.show();
    }

    showExportcuredata() {
        this.Exportcuredata.showModal()
    }

    render() {
        const {
            data,
            loading,
            pagination,
            curParams,
            searchParams,
            sortParams,
            businessList,
            contractTypeList,
            showFailureRecord,
            signingUnitOptions,
            belongingToUnitOptions,
            endMonth,
            startMonth,
            operable,
            isSeniorUserBo,
            FINANCE_INCOME_REPORT_USER,
            isDesignatedTal,
        } = this.state;
        const { curRole } = sessionStorage;
        const isFIN = curRole == 'FIN';
        const showFailureRecordBtn = isFIN || isSeniorUserBo || FINANCE_INCOME_REPORT_USER || isDesignatedTal;
        const { date } = curParams;
        return (
            <div className="content">
                <SideNav selectKey='financeIncomeReport' />
                <div className="main" style={{ display: showFailureRecord ? 'none' : 'block' }}>
                    <Filter
                        operable={operable}
                        expandHeight={160}
                        search={this.search}
                        params={searchParams}
                        endMonth={endMonth}
                        startMonth={startMonth}
                        businessList={businessList}
                        contractTypeList={contractTypeList}
                        onChange={this.handleFilterChange}
                        signingUnitOptions={signingUnitOptions}
                        belongingToUnitOptions={belongingToUnitOptions}
                        buttons={[
                            <Button key="export" type="primary" disabled={!operable} onClick={this.export}>导出</Button>,
                            showFailureRecordBtn && <Button key="failure" type="primary" className="yellow" disabled={!operable} onClick={() => this.showFailureRecord(true)}>失败记录</Button>,
                            <Button key="FieldSettings" type="primary" onClick={() => this.showFieldSettings()}>字段设置</Button>,
                            <Button key="Exportcuredata" type="primary" onClick={() => this.showExportcuredata()}>导出固化数据</Button>
                        ]}
                    />
                    <Exportcuredata
                        searchParams={searchParams}
                        ref={el => this.Exportcuredata = el} />
                    <TableC
                        data={data}
                        scrollY={500}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        // rowKey="investigationJdeContractRecordId"
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </div>
                <FieldSettingsModel ref={el => this.fieldSettingsRef = el} queryHead={this.queryHead} searchParams={searchParams} />
                {showFailureRecord && <FailureRecord date={searchParams && searchParams.dateEnd} showFailureRecord={this.showFailureRecord} />}
            </div>
        );
    }
}

export default FinanceIncomeReport;


// WEBPACK FOOTER //
// ./src/components/financeManagement/financeIncomeReport/index.js